import React, { Suspense, lazy } from "react"
import { useDispatch, useSelector } from "react-redux"
import { togglePopup } from "../../Actions/componentActions"
import { Loader } from "semantic-ui-react"

const ProfilePopup = lazy(() => import("./popUpPages/profile").then(module => ({ default: module.ProfilePopup })))
const CreateOrganizationPopup = lazy(() => import("./popUpPages/createOrganizagtion").then(module => ({ default: module.CreateOrganizationPopup })))
const ResearchBillOfRightsPopup = lazy(() => import("./popUpPages/researchBillOfRights").then(module => ({ default: module.ResearchBillOfRightsPopup })))

const PopUpComponent = () => {
    const popUpDetails = useSelector(state => state.componentReducer.popUpDetails)

    const { open = false, type, crossIcon = '', popUpPosition = 'top-1/2 left-1/2 -translate-x-[50%] -translate-y-[50%]', className = '', details } = popUpDetails
    const dispatch = useDispatch()

    const closePopUp = () => {
        dispatch(togglePopup({ open: false, type: '', crossIcon: false, className: '' }))
    }

    const openPopUp = (remainingdetails) => {
        dispatch(togglePopup({ open: true, ...remainingdetails }))
    }

    const renderComponebt = () => {
        switch (type) {
            case 'Profile':
                return <ProfilePopup openPopUp={openPopUp} closePopUp={closePopUp} />
            case 'create organization':
                return <CreateOrganizationPopup closePopUp={closePopUp} details={details} />
            case 'research bill of rights':
                return <ResearchBillOfRightsPopup closePopUp={closePopUp} />
            default:
                break;
        }
    }

    const handleOutSideClick = (e) => {
        let { id } = e.target;
        if(id === 'main-popup'){
            closePopUp();
        }
    }
    if (!open) return null
    let hasBackground = ['create organization', 'research bill of rights']
    return (
        <div className={`fixed modal z-[99999] top-0 w-full left-0 h-[100vh] ${hasBackground.includes(type) ? 'bg-gray-900/50' : ''}`} id="main-popup" onClick={handleOutSideClick} >
            <div className={`absolute ${popUpPosition} ${className}`}>
                <Suspense fallback={<Loader active inline='centered' />}>
                    {renderComponebt()}
                </Suspense>
            </div>
        </div>
    )

}

export default PopUpComponent;